'use strict';

var enUsLocaleData = require('date-fns/locale/en-US');
var koLocaleData = require('date-fns/locale/ko');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var enUsLocaleData__default = /*#__PURE__*/_interopDefault(enUsLocaleData);
var koLocaleData__default = /*#__PURE__*/_interopDefault(koLocaleData);

function getLocaleData(localesType) {
  switch (localesType) {
    case "ko": {
      return koLocaleData__default;
    }
    case "en": {
      return enUsLocaleData__default;
    }
  }
}

module.exports = getLocaleData;
//# sourceMappingURL=getLocaleData.cjs.map
